import styled from 'styled-components';

import { Card as BaseCard } from '@xing-com/card';
import {
  cornerRadiusXXL,
  spaceXL,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';

const Card = styled(BaseCard)`
  display: flex;
  border: 0;
  align-items: center;
  justify-content: center;
  padding: ${spaceXL};
  background-color: ${xdlColorBackgroundTertiary};
  height: 100%;
  border-radius: ${cornerRadiusXXL};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spaceXL};
`;

export const Styled = { Card, Content };
